import React from 'react';
import PropTypes from 'prop-types';
import Heading from '@cotyorg/ccx-atoms/Heading';
import IconLink from '@cotyorg/ccx-molecules/IconLink';
import ClearAllLink from '../ClearAllLink';

export const getOnClickHandler = ({ toggleFilter, optionName, categoryName }) => (e) => {
  e.preventDefault();
  toggleFilter({ optionName, categoryName });
};

export const generateSelectedFiltersURL = ({
  optionName = '',
  categoryName = '',
  selectedFilters = [],
}) => {
  const filters = selectedFilters
    .filter(selectedFilter => (
      selectedFilter.categoryName !== categoryName || selectedFilter.optionName !== optionName
    ));

  return `?filters=${JSON.stringify(filters)}`;
};

// istanbul ignore next
const SelectedFilters = ({
  selectedFilters,
  toggleFilter,
  setSelectedFilters,
  headingLevel,
  selectedFiltersHeadingText,
  selectedFilterIconSrc,
  clearAllText,
}) => (
  <div className="filter__selected-filters">
    <div className="grid-x grid-margin-x align-justify">
      <Heading extraClass="filter__selected-filters-heading cell auto" level={headingLevel}>
        {selectedFiltersHeadingText}
      </Heading>
      <div className="cell shrink">
        <ClearAllLink
          setSelectedFilters={setSelectedFilters}
          clearAllText={clearAllText}
        />
      </div>
    </div>
    <div className="grid-x align-middle">
      {
        selectedFilters.map(({ optionName, categoryName }) => (
          <IconLink
            key={`${categoryName}-${optionName}`}
            link={generateSelectedFiltersURL({ optionName, categoryName, selectedFilters })}
            iconSrc={selectedFilterIconSrc}
            extraClass="filter__selected-filter-link"
            textExtraClass="filter__selected-filter-link-text"
            iconExtraClass="filter__selected-filter-link-icon"
            iconAfterText
            onClick={getOnClickHandler({ toggleFilter, optionName, categoryName })}
          >
            {optionName}
          </IconLink>
        ))
      }
    </div>
  </div>
);

SelectedFilters.propTypes = {
  selectedFilters: PropTypes.arrayOf(PropTypes.shape({
    categoryName: PropTypes.string.isRequired,
    optionName: PropTypes.string.isRequired,
  })).isRequired,
  toggleFilter: PropTypes.func.isRequired,
  setSelectedFilters: PropTypes.func.isRequired,
  headingLevel: PropTypes.number.isRequired,
  selectedFiltersHeadingText: PropTypes.string.isRequired,
  selectedFilterIconSrc: PropTypes.string.isRequired,
  clearAllText: PropTypes.string.isRequired,
};

export default SelectedFilters;
